<h1 mat-dialog-title>{{ title }}</h1>

<ng-container *ngIf="{ count: conversations$ | async } as c">
    <div mat-dialog-content>
        <p *ngIf="c.count === undefined">Checking your chats…</p>
        <ng-container *ngIf="c.count !== undefined">
            <p *ngIf="c.count" class="warning">
                You're chatting with {{ c.count }} {{ c.count === 1 ? 'person' : 'people' }} about this {{ thing }}.
                Your chats stay, but the {{ thing }}'s link in them will stop working.
            </p>
            <p><ng-container *ngIf="data.sale">It'll be taken off the marketplace. </ng-container><ng-container *ngIf="data.accommodation">It'll be taken off corpers.ng. </ng-container>Are you sure you want to delete it?</p>
        </ng-container>
    </div>

    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Cancel</button>
        <button color="warn" mat-button cdkFocusInitial [disabled]="c.count === undefined" (click)="deletePost()">Delete</button>
    </mat-dialog-actions>
</ng-container>
